import { IonButton, IonHeader, IonIcon, IonToolbar, useIonToast } from "@ionic/react";
import { cogOutline, notificationsOutline, searchOutline, storefrontOutline } from "ionicons/icons";
import React from "react";
import { useHistory } from "react-router";
import { useAuth } from "../../../AuthProvider";
import useAuthService from "../../../hooks/useAuthService";
import IDXButtonIcon from "../IDXButtonIcon/IDXButtonIcon";
import IDXLogo from "../../../assets/icons/system/ECLIPTIC_NEW_BLACK_PNG_NO_PADDING_BETA.svg";

const ToolbarSearchBar: React.FC = () => {
    const history = useHistory();
    const { isAuthenticated } = useAuth();
    const { login } = useAuthService()
    const [present] = useIonToast();

    const openSettings = () => {
        history.push("/settings");
    }
    const openSearch = () => {
        history.push("/search");
    }

    const presentToast = (message: string, duration: number, icon: string) => {
        present({
            message: message,
            duration: duration,
            position: 'top',
            icon: icon,
            buttons: [
                {
                    text: 'Dismiss',
                    role: 'cancel',
                    handler: () => {
                        console.log('Dismiss clicked');
                    },
                },
            ],
            onDidDismiss: (e: CustomEvent) => console.log(`Dismissed with role: ${e.detail.role}`)
        });
    };

    // TODO: animate placeholder for search bar when clicked on but nothing typed in

    const handleSmokeShack = () => {
        history.push("/shop");
    }

    return (
        <>
            <IonHeader className="bg-grey">
                <IonToolbar>
                    <div className="flex flex-row justify-between items-center mx-2">
                        <div className="flex order-first gap-x-4">
                            <div>
                                <IonButton fill="clear" size="small" color="dark" onClick={openSearch}>
                                    <IDXButtonIcon size="text-2xl" icon={searchOutline} />
                                </IonButton>
                            </div>
                            <div>
                                <IonButton fill="clear" size="small" color="dark" onClick={() => handleSmokeShack()}>
                                    <IDXButtonIcon size="text-2xl" icon={storefrontOutline} />
                                </IonButton>
                            </div>
                        </div>
                        <div className="flex items-center justify-center pl-4"> {/* Adjust h-12 as needed */}
                            <IonIcon
                                icon={IDXLogo}
                                className="w-20 h-12" // This will make the icon fill the height of its container
                                onClick={() => history.push('/home')}
                            />
                        </div>
                        <div className="flex order-last gap-x-4">
                            <div className="opacity-0">
                                <IonButton fill="clear" size="small" color="dark"
                                    onClick={() => presentToast("Keeping track of alerts is almost here!", 3500, notificationsOutline)}>
                                    <IDXButtonIcon size="text-2xl" icon={notificationsOutline} />
                                </IonButton>
                            </div>
                            <div>
                                <IonButton fill="clear" size="small" color="dark"
                                    onClick={() => isAuthenticated ? openSettings() : login()}>
                                    <IDXButtonIcon size="text-2xl" icon={cogOutline} />
                                </IonButton>
                            </div>
                        </div>
                    </div>
                </IonToolbar>
            </IonHeader>
        </>
    );
};

export default ToolbarSearchBar;
